module.exports = __webpack_public_path__ + "img/sysDefault.b3f9820b.png";